import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectStrategyName } from '../../../../selectors/auction';
import { Autobroker } from './Autobroker';

export const AutobrokerContainer = () => {
  const strategyName = useSelector(selectStrategyName);

  return <Autobroker strategyName={strategyName} />;
};
